<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="details-page">
            <div class="row">
              <div class="col-lg-3">
                <Menu></Menu>
              </div>
              <div class="col-12 col-lg-9">
                <!---section start--------->
                <section class="section">
                  <div class="section-contents pt-1">
                    <router-view></router-view>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import Menu from "./common/Menu.vue";


export default {
  components: {
    Layout,
    Menu
  }
};
</script>
